import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "../CSS/forgot-password.css";
import { resetPassword } from "../../api/accounts";
import history from "../history/history";
import forgotPassword from "../assets/forgot-password.webp"
import forgotPasswordIos from "../assets/forgot-password.jpg"

export default function ForgetPassword() {
  const [visible, setVisibility] = useState(false);
  return (
    <div className="forgot-password-main">
      <div className="container-fluid" id="forgot-password-image-container">
      <picture>
        <source srcSet={forgotPassword} type="image/webp" />
        <source srcSet={forgotPasswordIos} type="image/png" />
        <img src={forgotPasswordIos} alt="Background" id="forgot-password-img" className="img-fluid" />
      </picture>
      </div>
      <div className="container" id="forgot-password-input-container">
        <h2>Forgot Password</h2>
        <p>No worries!</p>
      <div className="formik">
      <Formik
        initialValues={{ email: "" }}
        validationSchema={Yup.object({
          email: Yup.string()
            .email("Invalid email address")
            .required("An email address is required"),
        })}
        onSubmit={(values, { setSubmitting }) => {
          resetPassword(values.email)
            .then(() => {
              setSubmitting(false);
              setVisibility(true);
          window.setTimeout(() => {
            setVisibility(false);
            history.push("/login");
          }, 1500);
            })
            .catch((error) => {
              alert(error);
              setSubmitting(false);
            });
        }}
      >
        {({ touched, errors, isSubmitting }) => (
          <Form>
            <div className="form-group">
              <small className="form-text text-muted">
                Email
              </small>
              <Field
                type="email"
                name="email"
                placeholder="Enter email"
                className={`form-control ${
                  touched.email && errors.email ? "is-invalid" : ""
                }`}
              />
              <ErrorMessage
                component="div"
                name="email"
                className="invalid-feedback"
              />
            </div>
            <button
              type="submit"
              className="btn btn-primary btn-danger"
              disabled={isSubmitting}
            >
              {isSubmitting ? 
                    <div className="spinner-border" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                    : "Reset"}
            </button>
          </Form>
        )}
      </Formik>
      {visible ? (
        <div className="alert alert-success" role="alert">
          Email sent to reset password!
        </div>
      ) : null}
    </div>
    </div>
    </div>
  );
}
